import React from 'react';
import Spinner from 'react-spinner-material';
import { Line } from 'react-chartjs-2';

const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: true,
        position: 'top',
        labels: {
            fontColor: '#374151',
            fontSize: 12,
            padding: 15,
            usePointStyle: true
        }
    },
    layout: {
        padding: {
            top: 10,
            right: 10,
            bottom: 10,
            left: 10
        }
    },
    scales: {
        xAxes: [{
            gridLines: {
                display: true,
                color: 'rgba(0, 0, 0, 0.05)',
                drawBorder: false
            },
            ticks: {
                fontColor: '#6B7280',
                fontSize: 10,
                autoSkip: false, // Ensure all labels are shown
                maxRotation: 90, // Allow vertical rotation to fit long names
                minRotation: 45
            }
        }],
        yAxes: [{
            gridLines: {
                display: true,
                color: 'rgba(0, 0, 0, 0.05)',
                drawBorder: false
            },
            ticks: {
                fontColor: '#6B7280',
                fontSize: 11,
                beginAtZero: true,
                callback: function (value) {
                    return value + '%';
                },
                max: 100
            }
        }]
    },
    tooltips: {
        backgroundColor: 'rgba(17, 24, 39, 0.9)',
        titleFontSize: 13,
        bodyFontSize: 12,
        xPadding: 12,
        yPadding: 10,
        cornerRadius: 8,
        callbacks: {
            title: function (tooltipItems, data) {
                const index = tooltipItems[0].index;
                return data.fullLabels ? data.fullLabels[index] : data.labels[index];
            },
            label: function (tooltipItem, data) {
                const label = data.datasets[tooltipItem.datasetIndex].label || '';
                return `${label}: ${tooltipItem.yLabel.toFixed(1)}%`;
            }
        }
    }
};

export class ConformityTrendChart extends React.Component {
    render() {
        const { data, language } = this.props;

        if (!data) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%'
                }}>
                    <Spinner size={50} spinnerColor="#2CA8FF" spinnerWidth={2} visible={true} />
                </div>
            );
        }

        if (!data.labels || data.labels.length === 0) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    color: '#9CA3AF',
                    fontSize: '14px'
                }}>
                    Sem dados
                </div>
            );
        }

        const dataChart = {
            labels: data.labels,
            fullLabels: data.fullLabels,
            datasets: [
                {
                    label: language?.valid || 'Conformes',
                    data: data.conformityRates,
                    fill: true,
                    backgroundColor: 'rgba(34, 197, 94, 0.1)',
                    borderColor: '#22C55E',
                    borderWidth: 2,
                    pointBackgroundColor: '#22C55E',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    tension: 0.3
                },
                {
                    label: language?.improper || 'Não Conformes',
                    data: data.nonConformityRates,
                    fill: true,
                    backgroundColor: 'rgba(239, 68, 68, 0.1)',
                    borderColor: '#EF4444',
                    borderWidth: 2,
                    pointBackgroundColor: '#EF4444',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    tension: 0.3
                }
            ]
        };

        return (
            <Line data={dataChart} options={options} />
        );
    }
}
